import { render, staticRenderFns } from "./PatientAudiogram.vue?vue&type=template&id=cf65d13a&scoped=true"
import script from "./PatientAudiogram.vue?vue&type=script&lang=js"
export * from "./PatientAudiogram.vue?vue&type=script&lang=js"
import style0 from "./PatientAudiogram.vue?vue&type=style&index=0&id=cf65d13a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf65d13a",
  null
  
)

export default component.exports